import { Callout, List, ListRow, ModalHead, Prompt, PromptBody, Title } from 'admination-react'
import { useId } from 'react'
import { composeMassnahmeSelection } from '@/core/lib/massnahme'
import type {
  ZuweisungslisteFehlerZeile,
  ZuweisungslisteResult,
  ZuweisungslisteUebersprungen,
} from '../../api/zuweisungsliste'

function fehlerLineText(f: ZuweisungslisteFehlerZeile): string {
  return f.zeile == null ? f.grund : `Zeile ${f.zeile} · ${f.grund}`
}

export function ZuweisungslisteFehlerPrompt({
  meldung,
  fehler,
  onClose,
}: {
  meldung: string
  fehler: ZuweisungslisteFehlerZeile[]
  onClose: () => void
}) {
  return (
    <Prompt aria-label="Zuweisungsliste nicht übernommen" onEscape={onClose} topbar={<ModalHead onClose={onClose} closeLabel="Schließen" />}>
      <PromptBody>
        <Title as="h3">Zuweisungsliste nicht übernommen</Title>
        <p>{meldung}</p>
        <List>
          {fehler.map((f, i) => (
            <ListRow key={i} title={fehlerLineText(f)} />
          ))}
        </List>
      </PromptBody>
    </Prompt>
  )
}

function uebersprungenLineText(row: ZuweisungslisteUebersprungen): string {
  return `Zeile ${row.zeile} · Kd.-Nr. ${row.kundennummer} · ${row.nachname}, ${row.vorname}`
}

function keineMassnahmeText(unbekannt: string | null): string {
  return unbekannt === null
    ? "Die Zuweisungsliste nennt keine Maßnahmenummer. Die Teilnehmenden wurden daher keiner Maßnahme zugeordnet."
    : `Die Maßnahmenummer ${unbekannt} aus der Zuweisungsliste lässt sich keiner Maßnahme Ihrer Organisation eindeutig zuordnen. Die Teilnehmenden wurden daher keiner Maßnahme zugeordnet.`
}

export function ZuweisungslisteErgebnisPrompt({
  ergebnis,
  onClose,
}: {
  ergebnis: ZuweisungslisteResult
  onClose: () => void
}) {
  const titleId = useId()
  const { angelegt, uebersprungen, massnahme, massnahmenummer_unbekannt } = ergebnis
  return (
    <Prompt aria-labelledby={titleId} onEscape={onClose} topbar={<ModalHead onClose={onClose} closeLabel="Schließen" />}>
      <PromptBody>
        <Title as="h3" id={titleId}>{uebersprungen.length > 0 ? "Bereits vorhanden – übersprungen" : "Zuweisungsliste übernommen"}</Title>
        <p>{angelegt}{" Teilnehmende angelegt."}</p>
        {massnahme ? (
          <p data-testid="zuweisungsliste-massnahme">
            {"Maßnahme "}{composeMassnahmeSelection(massnahme.nummer, massnahme.bezeichnung)}
          </p>
        ) : (
          <Callout tone="warning" role="status" data-testid="zuweisungsliste-massnahme-hinweis">
            {keineMassnahmeText(massnahmenummer_unbekannt)}
          </Callout>
        )}
        {uebersprungen.length > 0 && (
          <List>
            {uebersprungen.map((row, i) => (
              <ListRow key={i} title={uebersprungenLineText(row)} />
            ))}
          </List>
        )}
      </PromptBody>
    </Prompt>
  )
}
